
import { Component, Vue } from "vue-property-decorator";
import Home from "@/components/Home2.vue";

@Component({
  components: {
    Home
  },
  meta: {
    // sets document title
    title: "Inicio - Municipalidad de Maipú",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Maipú"
      },
      keywords: { name: "keywords", content: "Maipú" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class HomeView extends Vue {
  private mounted() {
    document.title = "Inicio - Municipalidad de Maipú";
  }
}
